import React from 'react';

export function Alert({ children, variant = "default", className = "", ...props }) {
  const variantClasses = {
    default: "bg-gray-50 text-gray-900 border-gray-200",
    destructive: "bg-red-50 text-red-900 border-red-200",
  };
  
  return (
    <div className={`relative w-full rounded-lg border p-4 ${variantClasses[variant]} ${className}`} {...props}>
      {children}
    </div>
  );
}

export function AlertDescription({ className = "", children, ...props }) {
  return (
    <div className={`text-sm ${className}`} {...props}>
      {children}
    </div>
  );
}